import { useMutation } from '@tanstack/react-query';
import { createContext } from 'react';

import { axiosClient } from '@/services/BaseApi.service';

const TicketDetailsContext = createContext<() => void>(() => {
  // default no-op; overridden by the provider
});

export const useFetchTicketExport = () => {
  return useMutation({
    mutationFn: ({ format, id }: { format: 'json' | 'csv'; id: number }) => {
      const params = new URLSearchParams({
        export_format: format
      });
      return axiosClient.post(
        `/v2/tickets/export_details/${id}`,
        {},
        {
          params,
          responseType: 'blob'
        }
      );
    }
  });
};

export default TicketDetailsContext;
